import { useEffect, useState } from "react";
import {
  loadSessions,
  subscribeSessionsUpdated,
} from "../../lib/copilotSessionStorage";

export { saveSessionMeta } from "../../lib/copilotSessionStorage";

export function SessionSidebar({ activeId, onSelect, onNew, sessions: sessionsProp }) {
  const [tick, setTick] = useState(0);

  useEffect(() => subscribeSessionsUpdated(() => setTick((t) => t + 1)), []);

  const localSessions = Object.values(loadSessions());
  const merged = [...(sessionsProp || [])];
  const seen = new Set(merged.map((s) => s.id));
  for (const s of localSessions) {
    if (!seen.has(s.id)) merged.push(s);
  }
  const sessions = merged.sort(
    (a, b) => (b.updatedAt || 0) - (a.updatedAt || 0)
  );

  return (
    <aside className="cop-sidebar" data-sessions-tick={tick}>
      <div className="cop-sidebar-head">
        <button type="button" className="cop-new-btn" onClick={onNew}>
          + Nueva conversación
        </button>
      </div>
      <div className="cop-sessions">
        {sessions.length === 0 && (
          <p className="cop-sess-empty">Sin historial aún</p>
        )}
        {sessions.map((s) => (
          <button
            key={s.id}
            type="button"
            className={`cop-sess-item ${activeId === s.id ? "active" : ""}`}
            onClick={() => onSelect(s.id)}
          >
            <div className="cop-sess-title">{s.title || "Conversación"}</div>
            <div className="cop-sess-meta">
              <span>{s.tokens ? `${s.tokens} tok` : ""}</span>
              <span>{s.model || "sonnet"}</span>
            </div>
          </button>
        ))}
      </div>
      <div className="cop-sidebar-foot">
        <span className="cop-ws-dot">Copiloto TagNize</span>
      </div>
    </aside>
  );
}
